export const ERROR_TEXT_CODES_BY_CODE_NUMBER = {
  301: 'profiles.cannotDeleteProfilesAssignedToFleets',
  302: 'profiles.cannotDeletePublishedProfile',
  303: 'profiles.profileTreeHasMoreThanOnePublishedProfile',
  304: 'profiles.profileHasMoreThanOneNewestVersion',
  305: 'profiles.cannotAssignFleetsToUnpublishedProfiles',
};
